const { initInfoStyles } = require("./user");

/** FF kennt event.path nicht */
function MouseEventPathPolyfill() {
    if (!('path' in Event.prototype)) {
        const polyfill = ('composedPath' in Event.prototype)
            ? function () {
                return this.composedPath();
            }
            : function () {
                const path = [];
                let item = this.target;
                while (item) {
                    path.push(item);
                    item = item.parentElement;
                }
                return path;
            };
        Object.defineProperty(Event.prototype, 'path', {
            get: polyfill
        });
    }
}

MouseEventPathPolyfill();